var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMainCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 26C9.4122 26 6.1586 24.5426 3.80555 22.1896C1.45734 19.8366 0 16.5878 0 13.0001H7.04462C7.04462 14.6414 7.71277 16.1327 8.78762 17.2075C9.86731 18.2872 11.3537 18.9505 12.9999 18.9505V26Z",
    fill: "url(#paint0_linear_0_1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 0C9.4122 0 6.1586 1.45734 3.80555 3.80555C1.45734 6.1586 0 9.41219 0 12.9999L0.750458 14.4766L5.93588 14.4572L7.04462 12.9999C7.04462 11.3537 7.71277 9.86731 8.78762 8.78762C9.86731 7.71277 11.3537 7.04462 12.9999 7.04462V0Z",
    fill: "url(#paint1_linear_0_1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9995 26C16.5871 26 19.8359 24.5426 22.189 22.1896C24.542 19.8366 25.9993 16.5878 25.9993 13.0001H18.9499C18.9499 14.6414 18.2866 16.1327 17.2069 17.2075C16.132 18.2872 14.6408 18.9505 12.9995 18.9505V26Z",
    fill: "url(#paint2_linear_0_1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9997 0C16.5874 0 19.8361 1.45734 22.1892 3.80555C24.5422 6.1586 25.9996 9.41219 25.9996 12.9999L24.7843 13.8423L20.5769 13.8375L18.9501 12.9999C18.9501 11.3537 18.2868 9.86731 17.2071 8.78762C16.1322 7.71277 14.641 7.04462 12.9997 7.04462L12.1911 6.1586L12.1572 0.842449L12.9997 0Z",
    fill: "url(#paint3_linear_0_1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 7.04462,
    y1: 13.0001,
    x2: 12.9999,
    y2: 18.9505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92D050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01AC50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 4.49976,
    y1: 9.35225,
    x2: 10.4998,
    y2: 3.35224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92D050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E15B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 18.9499,
    y1: 13.0001,
    x2: 12.6315,
    y2: 18.9408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01AC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007A39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 20.9998,
    y1: 10.7235,
    x2: 14.4998,
    y2: 5.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01AC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E15B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainCircle);
export default __webpack_public_path__ + "static/media/mainCircle.de17210ce0837d0cea181afcd5f68a25.svg";
export { ForwardRef as ReactComponent };